// extracted by mini-css-extract-plugin
module.exports = {"ButtonGroup":"ConfirmationModal__ButtonGroup___1OhZb","Button":"ConfirmationModal__Button___3QF6o","TextWrapper":"ConfirmationModal__TextWrapper___37HtJ"};